module.exports = __webpack_public_path__ + "img/invite_android.76f3dd93.png";